/**
 * @author HungNS
 */
const GET_SYSTEM_CACHE = "getSystemCache";
const SET_SYSTEM_CACHE = "setSystemCache";
const GET_AMS_CUSTOMER_INFO = "getAmsCustomerInfo";
const SET_AMS_CUSTOMER_INFO = "setAmsCustomerInfo";
const INIT_FORCE_NEWS = "initForceNews";
const GET_VALIDATE_SELF_ASSET_AND_BO_MAX_LOSS="getValidateSelfAssetAndBoMaxLoss";
const VALIDATE_SELF_ASSET_AND_BO_MAX_LOSS="ValidateSelfAssetAndBoMaxLoss";
const SET_REMAIN_FORCE_NEWS_LIST = "setRemainForceNewsList";


export {
    GET_VALIDATE_SELF_ASSET_AND_BO_MAX_LOSS,
    VALIDATE_SELF_ASSET_AND_BO_MAX_LOSS,
    INIT_FORCE_NEWS,
    GET_SYSTEM_CACHE,
    SET_SYSTEM_CACHE,
    GET_AMS_CUSTOMER_INFO,
    SET_AMS_CUSTOMER_INFO,
    SET_REMAIN_FORCE_NEWS_LIST
};
